<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0 video-header" id="home">
        <div id="video_overlays"></div>
        <div class="shape shape-style-1 shape-default shape-skew video-header">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop">
            <source src="/static/video/background-movie.mp4" type="video/mp4">
          </video>
          <div class="col px-0 video-header-text">
            <div class="row">
              <div class="col-md-7">
                <h1 style="display:none">Link Asia Media Group Official Website</h1>
                <span class="display-1  text-white text-uppercase">
                  <p class="lead text-primary"><img src="/static/img/brand/small-logo.png" style="height:1em;" alt="link asia logo small">We serve as an extension to your marketing team.</p><b class="first">Make Connections</b>
                </span><br><span class="display-1 text-success text-uppercase"><b class="second">Localize Contents</b>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <section class="section section-lg pt-0 mt--100">
      <div class="container">
        <card gradient="primary" no-body shadow-size="lg" class="border-0">
          <div class="p-5">
            <div class="row align-items-center text-center">
              <div class="col-lg-12">
                <h3 class="text-white">Put Contents in Chinese Platform?</h3>
                <p class="lead text-white mt-3">"Never think about that"
                  <br>"unfamiliar......"
                  <br>"language barrier......"
                  <br>"culture difference......"
                </p>
                <p class="lead text-white font-weight-bold">
                  Before you make any decisions, have a look at the data and example we collected for you.
                </p>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
    <section class="section section-lg pt-0 mt--100" id="analysis">
      <div class="container pt-100 pb-100">
        <h2 class="display-3">Our Analysis</h2>
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <img src="/static/img/graphics.png" class="img-fluid floating" alt = "2013 - 2020 Chinese Internet Video Advertising Market">
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <p class="lead">2013 - 2020 Chinese Internet Video Advertising Market</p>
              <p>
                Chinese online video market has been increasing rapidly <b>since 2013</b>
                and the market growth is not going to slow down in the near future,
                since there are currently more than <b>800 million</b> Internet users in China,
                which can fairly be considered as the total of the United States and the entire Europe.
              </p>
            </div>
          </div>
        </div>
        <div class="row row-grid align-items-center">
          <div class="col-md-6">
            <div class="card border-0">
              <img src="/static/img/graphics2.png" class="img-fluid floating" alt="2018 Chinese Online Video Marketing Analysis">
            </div>
          </div>
          <div class="col-md-6">
            <div class="pl-md-5">
              <!--<icon name="ni ni-settings" class="mb-5" size="lg" type="warning" shadow rounded></icon>-->
              <!--<h3>2018 Chinese Online Video Marketing Analysis</h3>-->
              <p class="lead">2018 Chinese Online Video Marketing Analysis</p>
              <p>As we all known, the biggest revenue for video market comes from advertisement.
                The above histogram indicates the growth of the generated revenue from 2013 to 2018,
                and our predictions in the next two years.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-lg-0 mt--100 shape shape-style-3 bg-gradient-secondary" id="services">
      <div class="container">
        <div class="row justify-content-center text-center">
          <div class="col-lg-12">
            <div class="row row-grid text-center pt-100">
              <div class="col-lg-12">
                <h2 class="display-3">Our Services</h2>
              </div>
            </div>
            <div class="row row-grid">
              <div class="col-lg-3">
                <card class="border-0" hover body-classes="py-5">
                  <icon name="ni ni-tablet-button" type="primary" rounded class="mb-4">
                  </icon>
                  <h6 class="text-primary text-uppercase">Content <br>Marketing</h6>
                </card>
              </div>
              <div class="col-lg-3">
                <card class="border-0" hover body-classes="py-5">
                  <icon name="ni ni-chart-bar-32" type="success" rounded class="mb-4">
                  </icon>
                  <h6 class="text-success text-uppercase">Subtitle <br>Translation</h6>
                </card>
              </div>
              <div class="col-lg-3">
                <card class="border-0" hover body-classes="py-5">
                  <icon name="ni ni-lock-circle-open" type="warning" rounded class="mb-4">
                  </icon>
                  <h6 class="text-warning text-uppercase">Copyright <br>Protection</h6>
                </card>
              </div>
              <div class="col-lg-3">
                <card class="border-0" hover body-classes="py-5">
                  <icon name="ni ni-planet" type="info" rounded class="mb-4">
                  </icon>
                  <h6 class="text-info text-uppercase">Social <br>Media</h6>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg" id="platforms">
      <div class="container">
        <div class="row justify-content-center text-center mb-lg">
          <div class="col-lg-8">
            <h2 class="display-3">Our Platforms</h2>
            <p class="lead text-muted">We cooperate with below platforms.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <img v-lazy="'/static/img/platforms/qie.jpeg'" class="img-center img-fluid shadow shadow-lg--hover" style="width: 200px;" alt="qie platform logo">
              <div class="pt-4 text-center">
                <h5 class="title">
                </h5>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <img v-lazy="'/static/img/platforms/tiktok.jpg'" class="img-center img-fluid shadow shadow-lg--hover" style="width: 200px;" alt="tiktok logo">
              <div class="pt-4 text-center">
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <img v-lazy="'/static/img/platforms/toutiao.png'" class="img-center img-fluid shadow shadow-lg--hover" style="width: 200px;" alt="toutiao logo">
              <div class="pt-4 text-center">
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <img v-lazy="'/static/img/platforms/yuku.png'" class="img-center img-fluid shadow shadow-lg--hover" style="width: 200px;" alt="yuku logo">
              <div class="pt-4 text-center">
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <img v-lazy="'/static/img/platforms/iqiyi.jpg'" class="img-center img-fluid shadow shadow-lg--hover" style="width: 200px;" alt="iqiyi logo">
              <div class="pt-4 text-center">
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <img v-lazy="'/static/img/platforms/baijia.jpeg'" class="img-center img-fluid shadow shadow-lg--hover" style="width: 200px;" alt="baijia logo">
              <div class="pt-4 text-center">
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <img v-lazy="'/static/img/platforms/bilibili.png'" class="img-center img-fluid shadow shadow-lg--hover" style="width: 200px;" alt="bilibili logo">
              <div class="pt-4 text-center">
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <img v-lazy="'/static/img/platforms/dayu.jpeg'" class="img-center img-fluid shadow shadow-lg--hover" style="width: 200px;" alt="dayu logo">
              <div class="pt-4 text-center">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--
          <section class="section section-shape section-lg" id="team">
            <div class="container container-lg">
                <div class="row text-center">
                  <div class="col-lg-12">
                    <h2 class="display-3">Our<span class="text-success">Team</span></h2>
                    <p class="lead">Cause if you do, it can be yours</p>
                  </div>
                </div>
                <div class="row">
                    <div class="col-md-6 mb-5 mb-md-0">
                        <div class="card card-lift--hover shadow border-0">
                            <router-link to="/landing" title="Landing Page">
                                <img v-lazy="'/static/img/theme/landing.jpg'" class="card-img">
                            </router-link>
                        </div>
                    </div>
                    <div class="col-md-6 mb-5 mb-lg-0">
                        <div class="card card-lift--hover shadow border-0">
                            <router-link to="/profile" title="Profile Page">
                                <img v-lazy="'/static/img/theme/profile.jpg'" class="card-img">
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
          </section>
          -->
    <section class="section section-shaped my-0 overflow-hidden" id="facts">
      <div class="shape shape-style-3 bg-gradient-default shape-skew">
        <span></span><span></span><span></span><span></span></div>
      <div class="container pt-lg pb-300">
        <div class="row text-center justify-content-center">
          <div class="col-lg-12">
            <h2 class="display-3 text-white">Fun Facts</h2>
          </div>
        </div>
        <div class="row row-grid mt-5 text-center">
          <div class="col-lg-3">
            <div class="icon icon-shape icon-lg bg-gradient-white shadow text-primary" round=""><i class="ni ni-like-2"></i></div>
            <h5 class="text-white mt-3">120 Million</h5>
            <p class="text-white mt-3">Happy Subscribers</p>
          </div>
          <div class="col-lg-3">
            <div class="icon icon-shape icon-lg bg-gradient-white shadow text-primary" round=""><i class="ni ni-button-play"></i></div>
            <h5 class="text-white mt-3">24K</h5>
            <p class="text-white mt-3">Videos Published</p>
          </div>
          <div class="col-lg-3">
            <div class="icon icon-shape icon-lg bg-gradient-white shadow text-primary" round=""><i class="ni ni-world"></i></div>
            <h5 class="text-white mt-3">600 Million</h5>
            <p class="text-white mt-3">Views Generated</p>
          </div>
          <div class="col-lg-3">
            <div class="icon icon-shape icon-lg bg-gradient-white shadow text-primary" round=""><i class="ni ni-laptop"></i></div>
            <h5 class="text-white mt-3">8</h5>
            <p class="text-white mt-3">Cooperated Platforms</p>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-lg-0 section-contact-us" id="contact">
      <div class="container">
        <div class="row justify-content-center mt--300">
          <div class="col-lg-8">
            <card gradient="secondary" shadow body-classes="p-lg-5">
              <h4 class="mb-1">Get in Touch</h4>
              <p class="mt-0">We can't wait to hear from you.</p>
              <form @submit="formSubmit">
                <div v-if="result" role="alert" :class="'alert alert-'+outputClass+' alert-dismissible'">
                  <span class="alert-inner--text">
                      <span>{{respondMessage}}</span>
                  </span></div>
                <p v-if="errors.length">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="error in errors">{{ error }}</li>
                  </ul>
                </p>
                <div class="form-group input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="ni ni-user-run"></i>
                    </span>
                  </div>
                  <input v-model="name" aria-describedby="addon-right addon-left" placeholder="Your name" class="form-control">
                </div>
                <div class="form-group input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="ni ni-email-83"></i>
                    </span>
                  </div>
                  <input v-model="email" aria-describedby="addon-right addon-left" placeholder="Email address" class="form-control">
                </div>
                <textarea class="form-control form-control-alternative" v-model="message" rows="4" cols="80" placeholder="Type a message..."></textarea>
                <button type="submit" class="btn col mt-4 btn-block btn-default">Send Message</button>
              </form>
            </card>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style scoped>
  .video-header-text {
    z-index: 2;
  }

  .video-header {
    background: #fff !important;
  }

  #video_overlays {
    position: absolute;
    top: 50%;
    left: 50%;
    min-width: 1237.33px;
    min-height: 100%;
    z-index: 2;
    -ms-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    background-color: rgba(10, 0, 0, 0.5);
  }

  .video-header video {
    position: absolute;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    z-index: 0;
    -ms-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }

  .video-header .lead {
    font-weight: 900;
    font-style: italic;
    letter-spacing: 0.25em;
    font-size: 20px;
    margin: 0;
    color: rgba(138, 152, 235) !important;
  }

  .video-header hr {
    margin: 1px 0 0 0;
    border-top: 1px solid #fff;
  }
</style>
<script>
export default {
  name: "home",
  components: {},
  data() {
    return {
      errors: [],
      name: '',
      email: '',
      message: '',
      outputClass: '',
      result: false,
      respondMessage: '',
    };
  },
  methods: {
    checkform: function(e) {
      this.errors = [];

      if (!this.name) {
        this.errors.push("Name required.");
      }
      if (!this.email) {
        this.errors.push('Email required.');
      } else if (!this.validEmail(this.email)) {
        this.errors.push('Valid email required.');
      }
      if (!this.errors.length) {
        return true;
      }
    },
    formSubmit: function(e) {
      e.preventDefault();
      if(this.checkform()==true){
        let currentObj = this;
        this.axios.get('/send-email/send.php', {
            params: {
              name: this.name,
              email: this.email,
              message: this.message
            }
          })
          .then(function(res) {
            currentObj.result = true;
            currentObj.respondMessage = res.data.status+". ";
            currentObj.outputClass = "success";
          })
          .catch(function(error) {
            currentObj.result = true;
            currentObj.respondMessage = error+". Please try resubmit. ";
            currentObj.outputClass = "danger";
          });
      }
    },
    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      return re.test(email);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Landing.vue